import { API_BASE_URL, API_CUSTOM_BASE_URL } from "./apiURLConfig";

//?fields=["*"]&limit_page_length=0   for getting all records

export const USER_API_URLS = {
  SEND_OTP: `${API_CUSTOM_BASE_URL}/laundritek.laundritek_support.doctype.otp.otp.sendOtp`,
  VERIFY_OTP: `${API_CUSTOM_BASE_URL}/laundritek.laundritek_support.doctype.otp.otp.verifyOtp`,
  REGISTER_USER: `${API_CUSTOM_BASE_URL}/laundritek.laundritek_support.doctype.otp.otp.createUser`,
  GET_ALL_USERS: `${API_BASE_URL}/api/resource/User?fields=["*"]&limit_page_length=0`,
  CREATE_USER: `${API_BASE_URL}/api/resource/User/`,
  UPDATE_USER: `${API_BASE_URL}/api/resource/User/:id/`,
  DELETE_USER: `${API_BASE_URL}/api/resource/User/:id`,
  GET_USER_BY_ID: `${API_BASE_URL}/api/resource/User/:id`,
  GET_ALL_ACTIVITY_LOGS: `${API_BASE_URL}/api/resource/Activity Log/?fields=["*"]&limit_page_length=0`,
};

export const ORGANIZATION_API_URLS = {
  GET_ALL_ORGANIZATIONS: `${API_BASE_URL}/api/resource/Organization?fields=["*"]&limit_page_length=0`,
  CREATE_ORGANIZATION: `${API_BASE_URL}/api/resource/Organization/`,
  UPDATE_ORGANIZATION: `${API_BASE_URL}/api/resource/Organization/:id/`,
  DELETE_ORGANIZATION: `${API_BASE_URL}/api/resource/Organization/:id`,
  GET_ORGANIZATION_BY_ID: `${API_BASE_URL}/api/resource/Organization/:id`,
};

export const VOUCHER_API_URLS = {
  GET_ALL_VOUCHERS: `${API_BASE_URL}/api/resource/Voucher/?fields=["*"]&limit_page_length=0`,
  CREATE_VOUCHER: `${API_BASE_URL}/api/resource/Voucher/`,
  UPDATE_VOUCHER: `${API_BASE_URL}/api/resource/Voucher/:name`,
  DELETE_VOUCHER: `${API_BASE_URL}/api/resource/Voucher/:name`,
  GET_VOUCHER_BY_ID: `${API_BASE_URL}/api/resource/Voucher/:name`,
};

export const COUPON_API_URLS = {
  GET_ALL_COUPONS: `${API_BASE_URL}/api/resource/Coupon/?fields=["*"]&limit_page_length=0`,
  CREATE_COUPON: `${API_BASE_URL}/api/resource/Coupon/`,
  UPDATE_COUPON: `${API_BASE_URL}/api/resource/Coupon/:name`,
  DELETE_COUPON: `${API_BASE_URL}/api/resource/Coupon/:name`,
  GET_COUPON_BY_ID: `${API_BASE_URL}/api/resource/Coupon/:name`,
};

export const SHOP_API_URLS = {
  GET_ALL_SHOPS: `${API_BASE_URL}/api/resource/Shop/?fields=["*"]&limit_page_length=0`,
  CREATE_SHOP: `${API_BASE_URL}/api/resource/Shop/`,
  UPDATE_SHOP: `${API_BASE_URL}/api/resource/Shop/:name`,
  DELETE_SHOP: `${API_BASE_URL}/api/resource/Shop/:name`,
  GET_SHOP_BY_ID: `${API_BASE_URL}/api/resource/Shop/:name`,
};

export const MACHINE_API_URLS = {
  GET_ALL_MACHINES: `${API_BASE_URL}/api/resource/Machine/?fields=["*"]&limit_page_length=0`,
  CREATE_MACHINE: `${API_BASE_URL}/api/resource/Machine/`,
  UPDATE_MACHINE: `${API_BASE_URL}/api/resource/Machine/:name`,
  DELETE_MACHINE: `${API_BASE_URL}/api/resource/Machine/:name`,
  GET_MACHINE_BY_ID: `${API_BASE_URL}/api/resource/Machine/:name`,
  /** Get single machine by device_eui (use with filters). */
  GET_MACHINE_BY_DEVICE_EUI: `${API_BASE_URL}/api/resource/Machine/?fields=["*"]&limit_page_length=1`,
  GET_ALL_MACHINES_AND_PRICES: `${API_CUSTOM_BASE_URL}/laundritek.laundritek_machine.api.get_all_machines_and_child_tables`,
  GET_DEVICE_LOG: `${API_CUSTOM_BASE_URL}/laundritek.laundritek_machine.doctype.machine.machine.get_device_log`,
};

export const MACHINE_MODEL_API_URLS = {
  GET_ALL_MACHINE_MODELS: `${API_BASE_URL}/api/resource/Machine Model/?fields=["*"]&limit_page_length=0`,
  CREATE_MACHINE_MODEL: `${API_BASE_URL}/api/resource/Machine Model/`,
  UPDATE_MACHINE_MODEL: `${API_BASE_URL}/api/resource/Machine Model/:name`,
  DELETE_MACHINE_MODEL: `${API_BASE_URL}/api/resource/Machine Model/:name`,
  GET_MACHINE_MODEL_BY_ID: `${API_BASE_URL}/api/resource/Machine Model/:name`,
};

export const MACHINE_DEVICE_API_URLS = {
  GET_ALL_MACHINE_DEVICES: `${API_BASE_URL}/api/resource/Machine Device/?fields=["*"]&limit_page_length=0`,
  CREATE_MACHINE_DEVICE: `${API_BASE_URL}/api/resource/Machine Device/`,
  UPDATE_MACHINE_DEVICE: `${API_BASE_URL}/api/resource/Machine Device/:name`,
  DELETE_MACHINE_DEVICE: `${API_BASE_URL}/api/resource/Machine Device/:name`,
  GET_MACHINE_DEVICE_BY_ID: `${API_BASE_URL}/api/resource/Machine Device/:name`,
};

export const COMMAND_API_URLS = {
  GET_ALL_COMMANDS: `${API_BASE_URL}/api/resource/Command API/?fields=["*"]&limit_page_length=0`,
  CREATE_COMMAND: `${API_BASE_URL}/api/resource/Command API/`,
  UPDATE_COMMAND: `${API_BASE_URL}/api/resource/Command API/:name`,
  DELETE_COMMAND: `${API_BASE_URL}/api/resource/Command API/:name`,
  GET_COMMAND_BY_ID: `${API_BASE_URL}/api/resource/Command API/:name`,
};

export const STATE_API_URLS = {
  GET_ALL_STATES: `${API_BASE_URL}/api/resource/State/?fields=["*"]&limit_page_length=0`,
  CREATE_STATE: `${API_BASE_URL}/api/resource/State/`,
  UPDATE_STATE: `${API_BASE_URL}/api/resource/State/:name`,
  DELETE_STATE: `${API_BASE_URL}/api/resource/State/:name`,
  GET_STATE_BY_ID: `${API_BASE_URL}/api/resource/State/:name`,
};

export const DISTRICT_API_URLS = {
  GET_ALL_DISTRICTS: `${API_BASE_URL}/api/resource/District/?fields=["*"]&limit_page_length=0`,
  CREATE_DISTRICT: `${API_BASE_URL}/api/resource/District/`,
  UPDATE_DISTRICT: `${API_BASE_URL}/api/resource/District/:name`,
  DELETE_DISTRICT: `${API_BASE_URL}/api/resource/District/:name`,
  GET_DISTRICT_BY_ID: `${API_BASE_URL}/api/resource/District/:name`,
  GET_DISTRICTS_BY_STATE: `${API_BASE_URL}/api/resource/District/?fields=["*"]&filters=[["state_id","=",":stateId"]]&limit_page_length=0`,
};

/** Order doctype (backend uses Order, not Transaction) */
export const ORDER_API_URLS = {
  GET_ALL_ORDERS: `${API_BASE_URL}/api/resource/Order?fields=["*"]&limit_page_length=0`,
  CREATE_ORDER: `${API_BASE_URL}/api/resource/Order/`,
  GET_ORDER_BY_ID: `${API_BASE_URL}/api/resource/Order/:name`,
};

/** @deprecated Use ORDER_API_URLS — kept for compatibility; points to Order. */
export const TRANSACTION_API_URLS = {
  GET_ALL_TRANSACTIONS: ORDER_API_URLS.GET_ALL_ORDERS,
  CREATE_TRANSACTION: ORDER_API_URLS.CREATE_ORDER,
  GET_TRANSACTION_BY_ID: ORDER_API_URLS.GET_ORDER_BY_ID,
};

/** Issue doctype (Laundritek Support) — complaints from staff or customer. */
export const ISSUE_API_URLS = {
  GET_ALL_ISSUES: `${API_BASE_URL}/api/resource/Issue?fields=["*"]&limit_page_length=0`,
  GET_ALL_ISSUE_TYPES: `${API_BASE_URL}/api/resource/Issue Type?fields=["*"]&limit_page_length=0`,
  CREATE_ISSUE: `${API_BASE_URL}/api/resource/Issue/`,
  UPDATE_ISSUE: `${API_BASE_URL}/api/resource/Issue/:name`,
  DELETE_ISSUE: `${API_BASE_URL}/api/resource/Issue/:name`,
  GET_ISSUE_BY_ID: `${API_BASE_URL}/api/resource/Issue/:name`,
  /** Frappe file upload — multipart/form-data; returns file name/URL to set on Issue.upload_image */
  UPLOAD_FILE: `${API_BASE_URL}/api/method/upload_file`,
};

/** Refund request endpoint (customer/admin). */
export const REFUND_API_URLS = {
  REQUEST_REFUND: `${API_BASE_URL}/api/method/laundritek.api.request_refund`,
};
